module.exports = __webpack_public_path__ + "assets/img/no-message.8ff8dd75.gif";